export default function SectionApp() {
  return (
    <section id="app" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-xl p-6 md:p-10 border border-background-200/70">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-1.5 bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1.5 rounded-full mb-4 whitespace-nowrap">
              <i className="ri-smartphone-line"></i>
              随时随地吃瓜
            </div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-3">移动端专属入口</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              将黑料爆料吃瓜网添加到手机桌面，体验流畅的吃瓜之旅。无需下载安装，打开即用，与App体验一致。
              支持iOS和Android，51吃瓜与17c黑料爆料随时随地想看就看，地铁通勤、睡前刷瓜从未如此便捷。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="inline-flex items-center gap-2 bg-foreground-900 text-white px-5 py-2.5 rounded-lg cursor-pointer whitespace-nowrap">
                <i className="ri-apple-line text-lg"></i>
                <span className="text-sm font-semibold">iOS 添加桌面</span>
              </div>
              <div className="inline-flex items-center gap-2 bg-foreground-900 text-white px-5 py-2.5 rounded-lg cursor-pointer whitespace-nowrap">
                <i className="ri-android-line text-lg"></i>
                <span className="text-sm font-semibold">Android 添加桌面</span>
              </div>
            </div>
          </div>
          <div className="flex-1 w-full max-w-[400px] lg:max-w-none">
            <div className="relative mx-auto w-[240px] md:w-[280px] aspect-[9/16] rounded-2xl overflow-hidden border-4 border-foreground-900">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20mockup%20showing%20modern%20news%20feed%20with%20coral%20and%20warm%20color%20accents%2C%20entertainment%20gossip%20headlines%2C%20clean%20UI%20design%2C%20dark%20background%20with%20warm%20highlights%2C%20app%20interface%20mockup%2C%20editorial%20layout&width=560&height=996&seq=app-mock-2026-x3&orientation=portrait"
                alt="黑料爆料吃瓜网移动端界面预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}